import React from "react";
import Wprr from "wprr";

export default class FaqQuestion extends Wprr.BaseObject {
    _construct() {
        super._construct();

        this._elementTreeItem.requireValue("open", false);
    }

    _toogleOpen() {
        console.log("_toogleOpen");
        this._elementTreeItem.setValue("open", !this._elementTreeItem.getValue("open"));
    }

    _renderMainElement() {
        return <div className="faq-question-box">
            <Wprr.CommandButton  commands={Wprr.commands.callFunction(this, this._toogleOpen)}>
                <div className="faq-question-box-header faq-question-box-header-padding cursor-pointer">
                    <Wprr.FlexRow className="flex-row small-item-spacing vertically-center-items">
                        <div className="faq-icon">
                            +
                        </div>
                        <div className="faq-question-title no-margins">{Wprr.text(this.getFirstInput("question"))}</div>
                    </Wprr.FlexRow>
                </div>
            </Wprr.CommandButton>
            <Wprr.OpenCloseExpandableArea open={this._elementTreeItem.getValueSource("open")}>
                <div className="faq-question-box-answer faq-question-box-answer-padding">
                    <div className="wp-rich-text-formatting">
                        {Wprr.text(this.getFirstInput("answer"), "html")}    
                    </div>
                </div>
            </Wprr.OpenCloseExpandableArea>
        </div>;
    }
}
